module.exports = __webpack_public_path__ + "static/cac_logo_landscape_purple_on_transparent-1b68684451ca0c600214fdc751225546.png";